import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

import { artiaProtectedApi } from '@/lib/api-client';
import { DrugOption } from '../types/market-share';

const getMarketShareDrugs = (): Promise<DrugOption[]> => {
  return artiaProtectedApi.get('market-share/drugs');
};

export const makeMarketShareDrugsQueryKey = () => ['market-share', 'drugs'];

export const useMarketShareDrugs = () => {
  return useQuery({
    queryKey: makeMarketShareDrugsQueryKey(),
    queryFn: getMarketShareDrugs,
  });
};

export const useMarketShareDrugsSuspense = () => {
  const { data, error, isFetching, dataUpdatedAt } = useSuspenseQuery({
    queryKey: makeMarketShareDrugsQueryKey(),
    queryFn: getMarketShareDrugs,
  });

  if (error && !isFetching) throw error;

  return { data, dataUpdatedAt, isFetching };
};
